module.exports = __webpack_public_path__ + "static/sante-mag-couverture-0703c820c067b58c30b1cef1ccc020f4.jpg";